import { restApiClient } from '@/datasources';
import { Cart } from '@/types/cart.types';

export const ACTIVE_CART_ROUTE = '/online/cart';

export async function getActiveCart(signal?: AbortSignal): Promise<Cart | null> {
  const { data } = await restApiClient.get<Cart | undefined>(ACTIVE_CART_ROUTE, undefined, { signal });

  return data ?? null;
}
